module.exports = __webpack_public_path__ + "img/app store.469f65ff.svg";